//React code
//https://www.codegrepper.com/code-examples/javascript/multiple+image+upload+react



// useState https://itnext.io/add-state-and-lifecycle-methods-to-function-components-with-react-hooks-8e2bdc44d43d
 import React, { Suspense, lazy   }   from 'react'; 


 
// import React, { Component } from 'react';
//import ReactDOM from 'react-dom';

import { BrowserRouter, Route, Switch   } from 'react-router-dom';

  

//https://www.npmjs.com/package/react-cookie
//import { CookiesProvider, useCookies  } from 'react-cookie';

 
 import CssBaseline from '@mui/material/CssBaseline';
//import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

 

 //Docs
//Lazy loading
//https://reactjs.org/docs/code-splitting.html

 //https://www.golangprograms.com/how-to-create-simple-react-router-to-navigate-multiple-pages.html

 //dinamic styling
 //https://www.joyk.com/dig/detail/1532442610646595#parameters

 //add theme
 //https://material-ui.com/customization/color/
 //https://material-ui.com/customization/palette/
 //https://www.materialpalette.com/blue/amber
 //implement that
 //https://material-ui.com/customization/breakpoints/

 //dynamic Media queries
 //https://stackoverflow.com/questions/58305558/dynamic-media-querie-with-react-hooks

 
//import Grid from '@mui/material/Grid';

 import './App.css'; 
import {   theme, Tp_themeProvider } from "./Components/Theme/Theme"


import AppBar from './Components/AppBar/AppBar';
import Error from './Components/ErrorPage/Error';

//import GoTopButton from './Portal/ScrollToTopFab'
 

//import Cards from './Components/Cards/Cards';
import FooterBottomNavigation from './Components/FooterBottomNavigation/FooterBottomNavigation'
 //import { palette, spacing, typography } from '@material-ui/system';
 import BackToTop from './Portal/EditResearchComponents/BackToTop'

 //https://github.com/iamhosseindhv/notistack
 import { SnackbarProvider } from 'notistack';

//import MainPage from  "./Components/MainPage/MainPage";
//import Pricing from  "./StaticPages/Pricing";
//import AboutUs from  "./StaticPages/AboutUs";
 
//import Disclamer from  "./StaticPages/Disclamer";
//import CookiePolicy from  "./StaticPages/CookiePolicy";
//import PrivacyPolicy from  "./StaticPages/PrivacyPolicy";
 
//import TermsAndConditions from  "./StaticPages/TermsAndConditions";
//import Contact from  "./StaticPages/Contact";




 
 
//24-May-2021
// import $ from 'jquery';
// window.jQuery = $;
// window.$ = $;



const MainPage = lazy(() => import('./Components/MainPage/MainPage'));
// const BlobsPage = lazy(() => import('./Components/MainPage/mainSearchBlobs'));

const AboutUs = lazy(() => import('./StaticPages/AboutUs'));
//const NewsPage = lazy(() => import('./News/News'));
const Pricing = lazy(() => import('./StaticPages/Pricing'));
const ErrorPage = lazy(() => import('./StaticPages/Error'));
const Safety = lazy(() => import('./StaticPages/Safety'));
const CookiePolicy = lazy(() => import('./StaticPages/CookiePolicy'));
const PrivacyPolicy = lazy(() => import('./StaticPages/PrivacyPolicy'));
const RefundPolicy = lazy(() => import('./StaticPages/RefundPolicy'));
const TermsAndConditions = lazy(() => import('./StaticPages/TermsAndConditions'));
const Contact = lazy(() => import('./StaticPages/Contact')); 
const Support = lazy(() => import('./StaticPages/Support')); 
 
const Newsletters = lazy(() => import('./StaticPages/Newsletters')); 
const Signup = lazy(() => import('./StaticPages/SignupPage')); 
const HomePage = lazy(() => import('./StaticPages/HomePage')); 
const LoginPage = lazy(() => import('./StaticPages/LoginPage')); 
const LogoutPage = lazy(() => import('./StaticPages/LogoutPage')); 
const RestorepasswordPage = lazy(() => import('./StaticPages/RestorepasswordPage')); 
const ChangepasswordPage = lazy(() => import('./StaticPages/ChangepasswordPage')); 
const ActivatePage = lazy(() => import('./StaticPages/ActivatePage')); 
const ActivateinviteuserPage = lazy(() => import('./StaticPages/ActivateinviteuserPage')); 
 
const Search = lazy(() => import('./Portal/SearchPage'));
const ProfilePage = lazy(() => import('./Portal/ProfilePage.js'));
const MessagesPage = lazy(() => import('./Portal/MessagesPage.js'));
const CreateResearchPage = lazy(() => import('./Portal/EditResearchComponents/CreateResearchPage')); 
const EditResearchSettingsPage = lazy(() => import('./Portal/EditResearchComponents/EditResearchSettingsPage'));  
const EditResearchPage = lazy(() => import('./Portal/EditResearchComponents/EditResearchPage')); 

const EditResearchLookandFeelPage = lazy(() => import('./Portal/EditResearchComponents/EditResearchLookandFeelPage')); 
const EditResearchTranslationsPage = lazy(() => import('./Portal/EditResearchComponents/EditResearchTranslationsPage')); 
const EditResearchskipLogicPage = lazy(() => import('./Portal/EditResearchComponents/EditResearchskipLogicPage')); 
const EditResearchRatesQuotasPage = lazy(() => import('./Portal/EditResearchComponents/EditResearchRatesQuotasPage'));  
const EditResearchDistributionsPage = lazy(() => import('./Portal/EditResearchComponents/EditResearchDistributionsPage'));  
const EditWelcomePage = lazy(() => import('./Portal/EditResearchComponents/EditResearchWelcomePage')); 
const EditThankYouPage = lazy(() => import('./Portal/EditResearchComponents/EditResearchThankYouPage')); 
 

const InboxPage = lazy(() => import('./Portal/InboxPage.js')); 
const MyLikesPage = lazy(() => import('./Portal/MyLikesPage.js')); 
const WhoLikedMePage = lazy(() => import('./Portal/WhoLikedMePage.js')); 
 
const WhosViewMePage = lazy(() => import('./Portal/WhosViewMePage.js')); 

//removed 04-Oct-2022
// const MyInvitesPage = lazy(() => import('./Portal/MyInvitesPage.js')); 
//const InvitationsPage = lazy(() => import('./Portal/InvitationsPage.js')); 

const MyProjects = lazy(() => import('./Portal/MyProjectsPage.js')); 
const ShelveProjects = lazy(() => import('./Portal/MyProjectsShelvePage.js')); 
const EditProfilePage = lazy(() => import('./'));
const AccountsettingsPage = lazy(() => import('./Portal/AccountsettingsPage.js'));
//const MyAccountInitialSetupPage = lazy(() => import('./Portal/MyAccountInitialSetupPage.js')); 
const SettingsPage = lazy(() => import('./Portal/SettingsPage.js')); 
const CompanyprofilePage = lazy(() => import('./Portal/CompanyprofilePage.js'));
const ManageteamPage = lazy(async () => (await import('./Portal/ManageteamPage')));
const MembershipPage = lazy(() => import('./Portal/MembershipPage')); 
const DataAnalyticsPage = lazy(() => import('./Portal/DataAnalyticsPage')); 
const InsightsPage = lazy(() => import('./Portal/InsightsPage')); 
// const PayWithStripePage = lazy(() => import('./Portal/membership/paywithstripe')); 
const PayWithSquarePage = lazy(() => import('./Portal/membership/paywithsquare')); 
const PayWithPayPalPage = lazy(() => import('./Portal/membership/paywithpaypal')); 

 
//https://web.dev/code-splitting-suspense/?utm_source=lighthouse&utm_medium=devtools
//const renderLoader = () => <p>Loading</p>;
 


 //https://www.materialpalette.com/blue/amber
// usage https://material-ui.com/customization/color/
 
 /*
.text-primary-color    { color: #FFFFFF; }
.accent-color          { background: #FFC107; }
.primary-text-color    { color: #212121; }
.secondary-text-color  { color: #757575; }
.divider-color         { border-color: #BDBDBD; }
*/





/* https://www.cnbc.com/ 
const theme = createTheme(adaptV4Theme({
  palette: {
    primary: {
      light: '#4c81c5',
      main: '#005594',
      dark: '#002d66',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ffeb6d',
      main: '#EAB93B',
      dark: '#b48900',
      contrastText: '#000',
    },
  },
});  */

/* Amazon 
const theme = createTheme(adaptV4Theme({
  palette: {
    primary: {
      light: '#4987b7',
      main: '#232F3E',
      dark: '#00315a',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ffeb6d',
      main: '#EAB93B',
      dark: '#b48900',
      contrastText: '#000',
    },
  },
}));

end Amazon */

 
 
 


/* 
ReactDOM.render(
    routes,
    document.getElementById('root')
  );
*/

//https://stackoverflow.com/questions/41956465/how-to-create-multiple-page-app-using-react  
/*ReactDOM.render(
   
  routes,
  document.getElementById('root')
);*/

 

  
  
 

function App() {  
 
    //const classes = useStyles(); 
 
    //https://reactrouter.com/web/api/Hooks/uselocation
      


    // https://medium.com/@weberzt/importing-a-google-font-into-your-react-app-using-material-ui-773760ded532
    // https://fonts.google.com/specimen/Poppins
    // const font =  "'Poppins', sans-serif";
    // const theme = createTheme(adaptV4Theme({
    //   typography: {
    //     fontFamily: font,
    //     button: 
    //       textTransform: "none"
    //     }
    //   }
    // }));


  return ( 
 
  <div >
    
      <Tp_themeProvider theme={theme}> 
        <BrowserRouter>
       
   

  <SnackbarProvider maxSnack={3}>
  
    <div className="App">  
      <header  id="back-to-top-anchor">
        <AppBar />
      </header>
           <React.Fragment>
      <CssBaseline /> 
      <main   > 
      <Container maxWidth="lg">
       <Box>

    
       <Suspense fallback={<div></div>}>
      <Switch    > 
         <Route path="/search" component={MainPage} exact/> 

         <Route path="/" component={Signup} exact/>
         {/* <Route path="/index.html" component={HomePage} exact/>  */}
         <Route path="/index.html" component={Signup} exact/> 
    
         <Route exact  path="/pricing" component={Pricing}/> 
         <Route exact  path="/about-us" component={AboutUs}/>  
         {/* <Route exact  path="/safety" component={Safety}/>   */}
          
         <Route exact  path="/cookie-policy" component={CookiePolicy}/>  
         <Route exact  path="/privacy-policy" component={PrivacyPolicy}/>  
         <Route exact  path="/refund-policy" component={RefundPolicy}/>  
          
         <Route exact  path="/terms-of-service" component={TermsAndConditions}/>  
         <Route exact  path="/contact" component={Contact}/>  
         <Route exact  path="/support" component={Support}/> 
          
         <Route exact  path="/newsletters" component={Newsletters}/>  
          
         <Route exact  path="/signup" component={Signup}/>  
         <Route exact  path="/login" component={LoginPage}/>  
         <Route exact  path="/logout" component={LogoutPage}/> 
          <Route exact  path="/restorepassword/changepassword" component={ChangepasswordPage}/>     
         <Route exact  path="/restorepassword" component={RestorepasswordPage}/>  
               
         <Route exact  path="/activate" component={ActivatePage}/> 
         <Route exact  path="/activateinviteuser" component={ActivateinviteuserPage}/> 
          
         <Route exact    path="/search" component={Search}/>  
         <Route exact    path="/profile" component={ProfilePage} />   
         <Route exact    path="/profile/:id" component={ProfilePage}  />  

         <Route exact    path="/messages" component={MessagesPage} />   
         <Route exact    path="/messages/:id" component={MessagesPage}  />  

         <Route exact     path="/myprojects" component={MyProjects}/> 
         <Route exact     path="/shelveprojects" component={ShelveProjects}/> 
         <Route exact     path="/editwelcomepage" component={EditWelcomePage}/> 
         <Route exact     path="/editthankyoupage" component={EditThankYouPage}/> 
         <Route exact     path="/inbox" component={InboxPage}/>  
         <Route exact     path="/mylikes" component={MyLikesPage}/>   
         <Route exact     path="/whoslikedme" component={WhoLikedMePage}/>   
          
         {/* <Route exact     path="/myinvites" component={MyInvitesPage}/>  */}
         {/* <Route exact     path="/invitations" component={InvitationsPage}/>  */}
         <Route exact    path="/editprofile" component={EditProfilePage}/>   
         <Route exact    path="/whosviewedme" component={WhosViewMePage}/>  
          
         {/* <Route exact    path="/accountinitialsetup" component={MyAccountInitialSetupPage}/>   */}
             <Route exact    path="/accountsettings" component={AccountsettingsPage}/>   
             <Route exact    path="/settings" component={SettingsPage}/>  
             <Route exact    path="/createresearch" component={CreateResearchPage}/>  
             <Route exact    path="/editresearchsettings" component={EditResearchSettingsPage}/> 
             <Route exact    path="/editresearch" component={EditResearchPage}/>  

             <Route exact    path="/editresearchlookandfeel" component={EditResearchLookandFeelPage}/> 
             <Route exact    path="/editresearchtranslations" component={EditResearchTranslationsPage}/> 
             <Route exact    path="/editresearchskiplogic" component={EditResearchskipLogicPage}/> 
             <Route exact    path="/editresearchratesquotas" component={EditResearchRatesQuotasPage}/> 
             <Route exact    path="/editresearchdistributions" component={EditResearchDistributionsPage}/> 


 

             <Route exact    path="/dataanalytics" component={DataAnalyticsPage}/> 
             <Route exact    path="/insights" component={InsightsPage}/> 
               
             <Route exact    path="/companyprofile" component={CompanyprofilePage}/>   
             <Route exact    path="/manageteam" component={ManageteamPage}/> 
             <Route exact    path="/membership" component={MembershipPage}/>                 
             {/* <Route exact    path="/membership/paywithstripe" component={PayWithStripePage}/>   */}
             <Route exact    path="/membership/paywithsquare" component={PayWithSquarePage}/>  
             <Route exact    path="/membership/paywithpaypal" component={PayWithPayPalPage}/>  
               
  
        
        <Route component={Error}/>
        <Route exact  path="/error" component={ErrorPage} isAuthed={true}/> 
       </Switch>
       </Suspense>

</Box>
</Container> 
     
      </main> 
  
    </React.Fragment> 
 
 <footer  className="stickToBottom" > 
 <BackToTop />
   <FooterBottomNavigation   /> 
  
 </footer>
  
    </div>
  
        </SnackbarProvider>
 
     </BrowserRouter>
    </Tp_themeProvider>
  
</div>


  );
}

export default App;
